var map = {
	"./1.png": "a80e",
	"./2.png": "65470",
	"./3.png": "598b",
	"./4.png": "dde9",
	"./5.png": "16dc",
	"./6.png": "5c01",
	"./7.png": "24c0",
	"./8.png": "cd63",
	"./9.png": "1b6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ddfc";